import React from "react";
import { Card, Icon, Button } from "semantic-ui-react";

const ScanCard = ({ scan, pageNb, onView, onScan, onDelete, disabled, isSelected = false, isNotOriginal = false, movePrescriptionScan }) => {
	return (
		<Card
			color={isSelected ? "yellow" : "black"}
			style={{
				backgroundColor: isSelected ? "#f7f0c7" : "white",
			}}
		>
			<Card.Content>
				<Card.Header>
					{scan.default || scan.isDefaultScan ? "" : <Icon name="checkmark box" />}
					{scan.document_type?.title} - n° {pageNb}{" "}
				</Card.Header>
				<Card.Description>
					{scan.barcode && <div>Code-barres : {scan.barcode}</div>}
					{scan && !scan.validated && !scan.barcode && scan.fromSafeplace && <div style={{ color: "red" }}>!! Ordonnance non validée !!</div>}
					{scan && scan.validated && !scan.barcode && scan.fromSafeplace && (
						<>
							{" "}
							{scan.to_be_rescan && (
								<div style={{ color: "red" }}>
									Ordo reçue de mauvaise qualité <br /> Cliquez sur le CB pour la rescanner
								</div>
							)}
							{scan.quality_validated && (
								<div style={{ color: "green" }}>
									Ordo reçue de bonne qualité <br /> Ne pas rescanner l'ordonnance, la mettre directement dans la farde des ordonnances
								</div>
							)}
							{!scan.quality_validated && !scan.to_be_rescan && (
								<div style={{ color: "orange" }}>Attention : La qualité de l'ordonnance reçue est à évaluer !</div>
							)}
						</>
					)}
				</Card.Description>
			</Card.Content>
			<Card.Content extra>
				<div className="ui three buttons">
					<Button basic color="green" onClick={onView}>
						<Icon name="eye" />
					</Button>
					<Button basic color="blue" onClick={onScan} disabled={disabled || isNotOriginal}>
						<Icon name="barcode" />
					</Button>
					<Button basic color="red" onClick={onDelete} disabled={disabled || isNotOriginal}>
						<Icon name="trash" />
					</Button>
				</div>
				{movePrescriptionScan &&
					movePrescriptionScan.active &&
					movePrescriptionScan.prescriptions
						.filter((p) => p.number !== movePrescriptionScan.current.number)
						.map((p) => (
							<div style={{ width: "100%" }} key={`assoc-${scan.id}-${p.p.id}`}>
								<Button
									style={{ width: "100%" }}
									basic
									color="teal"
									onClick={() => movePrescriptionScan.updateScanPrescription(scan.id, p.p.id, movePrescriptionScan.current.p.id)}
									disabled={disabled || isNotOriginal}
								>
									<Icon name="exchange" />
									Déplacer vers Prescription N° {p.number}
								</Button>
							</div>
						))}
			</Card.Content>
		</Card>
	);
};

export default ScanCard;
